import {AppConfigEntries} from '../shared/app-config-settings-enum';

export interface HelpItem {
  id: string;
  appConfigName: string | AppConfigEntries;
  eventName: string;
  displayText: string;
}

export const standardHelpItems: HelpItem[] = [{
  id: 'glossary-link',
  appConfigName: AppConfigEntries.GLOSSARY,
  eventName: 'Glossary',
  displayText: 'Glossary'
}, {
  id: 'methodologyDocument-link',
  eventName: 'Methodology Document',
  appConfigName: AppConfigEntries.METHODOLOGY_DOCUMENT,
  displayText: 'Methodology Document'
}, {
  id: 'quickStartGuide-link',
  eventName: 'Quick Start Guide',
  appConfigName: AppConfigEntries.OPEN_QUICK_START_GUIDE,
  displayText: 'Quick Start Guide'
}, {
  id: 'dashboardOverview-link',
  appConfigName: AppConfigEntries.DASHBOARD_OVERVIEW,
  eventName: 'Dashboard Overview',
  displayText: 'Dashboard Overview'
}, {
  id: 'email-link',
  appConfigName: AppConfigEntries.SUPPORT_EMAIL,
  eventName: 'Contact Us',
  displayText: 'Contact Us'
}];

export const releaseNotes: HelpItem = {
  id: 'release-notes',
  appConfigName: '',
  displayText: 'Release Notes',
  eventName: 'Release Notes'
};
